<agpr-master-layout [id]="'discover'" [allowFullWidth]="fullWidth">
    <ng-template let-item agprTemplate="navigation">
        <agpr-left-sidebar [sidebarColorTheme]="sidebarColorThemesEnum.PALE"></agpr-left-sidebar>
        @if (emailAccountReAuthRequired) {
            <!-- TODO: Pull out into separate toast class? -->
            <div class="agpr-discover-message">
                <agpr-message
                    [severity]='severityEnum.warning'
                    [centerContent]="true"
                    [noBottomCornerRadius]="true"
                    [style]="componentStyle.social"
                    [closeable]="true"
                    (dismiss)="ignoreReAuthToast()"
                >
                    <p>{{'Discover.reauthenticateEmailAccount.text1' | localize}}</p>
                    <agpr-button
                        class="agpr-discover-message-link"
                        label="Common.dialog.aiDistributionHeader.sendFrom.popover.reauth.link"
                        [style]="buttonTypes.link"
                        (click)="navigateToDataConnectors()"
                    ></agpr-button>
                </agpr-message>
            </div>
        }
    </ng-template>
</agpr-master-layout>
